"use client";

import { useTheme } from "@up/data";
import { Auth, BrowserOnly, followRedirectParam } from "@up/ui";
import { useRouter } from "next/navigation";

export default function SignInPage() {
  const router = useRouter();
  const theme = useTheme();

  const onSuccess = function () {
    followRedirectParam(router);
  };

  return (
    <div className="slice-padding max-w-xl mx-auto pt-8 px-8">
      <div className="mb-8">
        <h1 className={theme.heading1Class}>Sign In</h1>
      </div>
      <BrowserOnly>
        <Auth onSuccess={onSuccess} />
      </BrowserOnly>
    </div>
  );
}
